import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import FileUploadAndCrop from "../../components/FileUploadAndCrop/FileUploadAndCrop";
import { Icon } from "../../components/Icon";
import checkRole from "../../helpers/checkRole";
import getDate from "../../helpers/getDate";
import { editUser, setCurrentUserDetails, setUserDetails } from "../../redux/actions/user";
import AdminProfileSettingsPage from "./AdminProfileSettingsPage/AdminProfileSettingsPage";
import AdminProfileWalletPage from "./AdminProfileWalletPage/AdminProfileWalletPage";
import { addNote, updateNote } from "../../redux/actions/user";

import ProfileGamesPage from './ProfileGamesPage/ProfileGamesPage';
import ProfileRoomsPage from './ProfileRoomsPage/ProfileRoomsPage';
import ProfileSettingsPage from "./ProfileSettingsPage/ProfileSettingsPage";
import ProfileWalletPage from "./ProfileWalletPage.jsx/ProfileWalletPage";
import Filter from "../../components/Filter/Filter";

const coverImg ={
    initialAspectRatio: 35 / 10,
    aspectRatio: 35 / 10,
    autoCropArea: 35 / 10,
    height: '200px',
    width: '320px',
    size: 10,
    type: 'coverImg',
    disabled: false
};

const avatarImg ={
    initialAspectRatio: 5 / 5,
    aspectRatio: 1,
    autoCropArea: 1,
    height: '200px',
    width: '320px',
    size: 10,
    type: 'avatarImg',
    text: "блог",
    disabled: false
};

const VerificationBadge = (props) => {
    const { t } = useTranslation();
    
    const computeVerificationValues = () => {

        if (props.isDelete) {
            const deleteDate = new Date(props.deleteDate)
            const today = new Date();
            let text;

            if (deleteDate < today) {
                text = 'Дані видалено';
            } else {
                text = 'Запит на видалення';
            }

            return {
                classNames: 'reputationNumber notVerified prFlexRow',
                text: text,
                type: 'deleted'
            }
        }

        if (props.isBlock) {
            return {
                classNames: 'reputationNumber notVerified prFlexRow',
                text: 'Заблоковано',
                type: 'block'
            }
        }

        switch(props.isStatus) {
            case 0:
                return {
                    classNames: 'reputationNumber notVerified prFlexRow',
                    text: 'status_not',
                };
            case 1: 
                return {
                    classNames: 'reputationNumber pendingVerification prFlexRow',
                    text: 'Очікує на верифікацію',
                };
            case 2: 
                return {
                    classNames: 'reputationNumber verified prFlexRow',
                    text: 'status_verificated',
                };
            default:
                return {
                    classNames: 'reputationNumber notVerified prFlexRow',
                    text: 'status_not',
                };
        }
    };

    const { classNames, text, type } = computeVerificationValues();

    return (
        <div className="profileStatus">
            <div className='prFlexRow'>
                <div className={`${classNames}`}> <Icon type={type !== 'block' ? 'passport' : 'error'}/> <div>{t(`${text}`)}</div> </div>
            </div>
        </div>
    )
}

const ProfilePage = () => {
    const { t } = useTranslation();
    const [form, setForm] = useState({});
    const [isOpen, setIsOpen] = useState(false);
    const [comment, setComment] = useState('');
    const [note, setNote] = useState({});
    const navigate = useNavigate();
    const dispatch=useDispatch();
    const system = useSelector(state => state.system);
    const type = useParams().type;
    const id = useParams().id;
    const location = useLocation();
    const userCur = useSelector((state) => state.currentUser.user);
    const user = useSelector((state) => state.user.currentUser?.user);

    const tabClick=(e)=>{
        if(!id){
            navigate('/profile/'+e.target.id);
        }else{
            navigate('/profile/'+e.target.id+'/'+id);
        }
    }

    const saveEdit = useCallback((data) => {
        let body = { ...data };
        body.id = id || userCur.id;
        dispatch(editUser(body)).then(res => {
            if (!id) {
                dispatch(setCurrentUserDetails(res));
            } else {
                dispatch(setUserDetails(res));
            }
        });
    }, [id, userCur, dispatch]);

    const changeHandler = (event) => {
        setComment(event.target.value);
    };

    const onCommentLeft = () => {
        const data = {
            description: comment
        }

        if (note.id) {
            data.id = note.id;
            dispatch(updateNote(data));
        } else {
            data.onWhom = id;
            dispatch(addNote(data));
        }
    };

    useEffect(() => {
        if (userCur && checkRole(userCur, 'arbitr') && location.pathname === '/') {
            navigate('/profile/settings', { replace: true })
        }

        if (userCur?.userNote?.length > 0) {

            const note = userCur.userNote.find(note => (note.onWhom === id)) || null;

            if (note) {
                setComment(note.description);
                setNote(note)
            };
        }
    }, [userCur, location.pathname])

    return (<>
        {userCur && userCur.isStatus == 0 && (
            <div className="attentionPart dFlex profileInformer" style={{ marginBottom: '35px' }}>
                <div className="warningModalIcon"> <Icon type='warning'></Icon></div>
                <div>
                    <h3>Акканут не верифіковано</h3>
                    <div>Будь ласка пройдіть верифікацію <a href="/verification">за посиланням</a></div>
                </div>
            </div>
        )}

        {userCur && system?.SettingsPromo?.isPromo && (getDate('','ssss') <= getDate(system?.SettingsPromo?.startActive,'ssss')) &&  (
            <div className="attentionPart dFlex profileInformer" style={{ marginBottom: '35px' }}>
                <div className="warningModalIcon"> <Icon type='warning'></Icon></div>
                <div>
                    <h3>Ви знаходитесь на промо-сервері Rivals Room.</h3>
                    <div>Можливість створення кімнат стане доступна о {getDate(system?.SettingsPromo?.startActive,'hh:mm dd/mmmm/yyyy',' ')}. Тим часом ви можете додати до своєї бібліотеки ті дисципліни, які вас цікавлять.</div>
                </div>
            </div>
        )}

        {userCur && system?.SettingsPromo?.isPromo && 
            (getDate('','ssss') >=  getDate(system?.SettingsPromo?.startActive,'ssss')) && 
            (getDate('','hh:mm dd/mmmm/yyyy',' ') <= getDate(system?.SettingsPromo?.finishActive,'ssss')) &&  (
            <div className="attentionPart dFlex profileInformer" style={{ marginBottom: '35px' }}>
                <div className="warningModalIcon"> <Icon type='warning'></Icon></div>
                <div>
                    <h3>Увага, це промо-сервер, який демонструє наявний функціонал Rivals Room.</h3>
                    <div>О {getDate(system?.SettingsPromo?.finishActive,'hh:mm dd/mmmm/yyyy',' ')} всю інформацію з цього сервера буде видалено, але ви завжди зможете використовувати наш <a className="link" target="_blank" href="https://my.rivalsroom.com/">основний сервер</a> . Доступи до облікового запису ідентичні.</div>
                </div>
            </div>
        )}



        <div className="profileMainBlock prFlexRow" style={{backgroundImage:`url(${id? (user?.coverImg || ''): (userCur?.coverImg || '')})`}} >
            <div className="photoUploadCover" >
                <FileUploadAndCrop key={`cover-${coverImg.type}`} setForm={setForm} saveEdit={saveEdit} form={form} options={coverImg}></FileUploadAndCrop>
            </div>
            <div className="profileMainBlockInfo prFlexRow">  
                <div className="headerUserAvatarBlock">
                    <div className='headerUserAvatar' style={{backgroundImage:`url(${id? (user?.avatarImg|| ''):(userCur?.avatarImg||'')})`}} >
                        {((id && !user?.avatarImg)||(!id && !userCur?.avatarImg)) && <Icon type='avatar'></Icon>}
                    </div>
                    <div className="headerUserAvatarUpload">
                        <FileUploadAndCrop key={`avatar-${avatarImg.type}`}  setForm={setForm} saveEdit={saveEdit} form={form} options={avatarImg}></FileUploadAndCrop>
                    </div>
                </div>
                <div className="profileMainBlockInfoRight">
                    <div className="prFlexRow profileMainBlockInfoRightText">
                        <div className='prFlexRow'>
                            <div  className={
                                        (user?.reputation > 6 || userCur?.reputation > 6) ? "reputationNumber" :
                                        ((user?.reputation < 7 && user?.reputation > 3)|| (userCur?.reputation < 7 && userCur?.reputation > 3) ) ? "reputationNumber caution":
                                        ((user?.reputation < 4||userCur?.reputation < 4 ) ? "reputationNumber error":'')
                                    }>{user?.reputation ||userCur?.reputation }</div>
                        </div>
                        <div className="profileFio"> {((id && user?.lastName) ||(!id&& userCur?.lastName)) ? (id && user?.lastName) || (!id && userCur?.lastName):t('last_name')} {((id && user?.firstName)|| (!id &&userCur?.firstName))? ( id && user?.firstName)|| ( !id && userCur?.firstName): t('first_name')}</div>
                        {id && (
                            <div
                                style={{paddingTop:'3px'}}
                                className='profileFioEditName'
                                onClick={() => {setIsOpen(true)}}
                            >
                                <Icon type='notepad'></Icon>
                            </div>
                        )}
                    </div>
                    <div className="profileMainBlockInfoRightNick">
                        @{(id&& user?.nickname )|| (!id && userCur?.nickname)}
                    </div>
                    {
                        (user || userCur) &&
                        (typeof user?.isStatus === 'number' || typeof userCur?.isStatus === 'number') &&
                        <VerificationBadge
                            isStatus={id ? user?.isStatus : userCur?.isStatus}
                            isDelete={id ? user?.isDelete : userCur?.isDelete}
                            isBlock={id ? user?.isBlock : userCur?.isBlock}
                            deleteDate = {id ? user?.deleteDate : userCur?.deleteDate}
                        />
                    }
                    <div className="prFlexRow statistic">
                        <div className="prFlexRow white"><Icon type='playController'/><div className="statisticValue">&nbsp;: {(id && user?.generalStatistics?.total) || (!id && userCur?.generalStatistics?.total) || '0' }</div></div>
                        <div className="prFlexRow green"><Icon type='win'/><div className="statisticValue">&nbsp;:  {(id &&user?.generalStatistics?.win) || (!id &&userCur?.generalStatistics?.win) || '0'}</div></div>
                        <div className="prFlexRow red"><Icon type='loose'/><div className="statisticValue">&nbsp;:  {(id &&user?.generalStatistics?.loss) || (!id &&userCur?.generalStatistics?.loss) || '0'}</div></div>
                        <div className="prFlexRow orange"><Icon type='draft'/><div className="statisticValue">&nbsp;:  {(id &&user?.generalStatistics?.draw) || (!id &&userCur?.generalStatistics?.draw) || '0'}</div></div>
                    </div>
                </div>

            </div>
            <div className="profileTabs prFlexRow" style={{ justifyContent: 'flex-start' }}>
                { (!id && userCur &&checkRole(userCur,'isVerified')) && <div onClick={tabClick} id='myGames' className={(user &&checkRole(user,'isVerified') || userCur &&checkRole(userCur,'isVerified')) && (!type || type=='myGames') ? "profileTabsItems active ":"profileTabsItems"}>{t('my_games')}</div>}
                { (!id &&userCur &&checkRole(userCur,'isVerified'))  && <div onClick={tabClick} id='rooms' className={type=='rooms' ?"profileTabsItems active":"profileTabsItems"}>{t('rooms')}</div>}
                {userCur && ((id && checkRole(userCur, 'superAdmin')) || !id) && <div onClick={tabClick} id='wallet' className={((!type && id)|| type==='wallet')?"profileTabsItems active":"profileTabsItems"}>{t('wallet')}</div>}
                <div onClick={tabClick} id='settings' className={type=='settings' ?"profileTabsItems active":"profileTabsItems"}>{t('settings')}</div>
            </div>
        </div>
        
        {
            ((user && user.blockReason && user.userBlock) ||
            (userCur && userCur.blockReason && userCur.userBlock)) &&
            (
            <div className="attentionPart dFlex profileInformer error" style={{ marginBottom: '40px' }}>
                <div className="warningModalIcon error"> <Icon type='error'></Icon></div>
                <div>
                    <h3>Ваш обліковий запис заблоковано</h3>
                    <div>
                        {
                            (user && user.blockReason && user.userBlock ? `Заблоковано до: ${getDate(user.userBlock, 'dd/mm/yyyy hh:mm', '.')}` : '') ||
                            (userCur && userCur.blockReason && userCur.userBlock ? `Заблоковано до: ${getDate(userCur.userBlock, 'dd/mm/yyyy hh:mm', '.')}` : '')
                        }
                    </div>
                </div>
            </div>
        )}

        {((user && user.deleteDate) || (userCur && userCur.deleteDate)) && (
            <div className="attentionPart dFlex profileInformer error" style={{ marginBottom: '40px' }}>
                <div className="warningModalIcon error"> <Icon type='warning'></Icon></div>
                <div>
                    <h3>Надіслано запит на видалення</h3>
                    <div>
                        {`Персональні дані буде видалено `}
                        {(user && user.isDelete && getDate(user.deleteDate,'dd/mm/yyyy','.')) || (userCur && userCur.isDelete && getDate(userCur.deleteDate,'dd/mm/yyyy','.'))}
                    </div>
                </div>
            </div>
        )}

        {((user && user.verificationReason) || (userCur && userCur.verificationReason)) && (
            <div className="attentionPart dFlex profileInformer" style={{ marginBottom: '70px' }}>
                <div className="warningModalIcon"> <Icon type='warning'></Icon></div>
                <div>
                    <h3>Вам відмовлено у верифікації</h3>
                    <div>{(user && user.verificationReason) || (userCur && userCur.verificationReason)}</div>
                </div>
            </div>
        )}

        {(user &&checkRole(user,'isVerified') || userCur &&checkRole(userCur,'isVerified'))  && (!type || type=='myGames') && 
            <ProfileGamesPage></ProfileGamesPage>
        }
        {
            type && type==='rooms' &&
            <ProfileRoomsPage></ProfileRoomsPage>
        }
        {((!id && type && type==='wallet')||
           ( !type && id)) &&
            <ProfileWalletPage/>
        }
        {
            type && type==='settings' && !id &&
            <ProfileSettingsPage isVerified={(user &&checkRole(user,'isVerified') || userCur &&checkRole(userCur,'isVerified'))}/>
        }
        {id && (!type || type==='wallet') && userCur&& checkRole(userCur,'superAdmin') && 
            <AdminProfileWalletPage />
        }
        {id && type && type==='settings' && userCur && checkRole(userCur,'admin') && 
            <AdminProfileSettingsPage/>
        }
        {id && isOpen && <Filter type='playerNote' user={user} form={comment} accept={onCommentLeft} onChange={changeHandler} isOpen={isOpen} setIsOpen={setIsOpen} />}
        </>
    );
};

export default ProfilePage;